import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  public isRefresh = false;
  public refreshApiLinks$ = new BehaviorSubject(this.isRefresh);

  constructor() { }


  public set isRefreshApilinks(val: boolean) {
    this.isRefresh = val;
  }

  public updateRefreshApiLinks() {
    this.refreshApiLinks$.next(this.isRefresh);
  }
}
